import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, Button, Grid, GridItem, Heading, Text, useBreakpointValue, useDisclosure } from "@chakra-ui/react";
import { useAuth } from "../auth/AuthProvider";
import { useLocation } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import ResponsiveSidebarWrapper from "../Navigation/ResponsiveSidebarWrapper";

function pluralize(word) {
  const exceptions = {
    trip: "Trips",
    order: "Orders",
    buyer: "Buyers",
    seller: "Sellers",
    truck: "Trucks",
    dashboard: "Dashboards",
  };

  return exceptions[word.toLowerCase()] || word + "s";
}

// Dummy authentication function, you should replace it with your actual authentication logic
const isAuthenticated = () => {
  // Check if the user is authenticated, e.g., by verifying if a token is present
  const token = localStorage.getItem("token");
  return !!token; // !! converts value to boolean
};

const PrivateRoute = ({ element, children, ...rest }) => {
  const { screens } = useAuth();
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isMobile = useBreakpointValue({ base: true, md: false });
  const path = location.pathname.split("/").pop();
  const accessPages =
    !!screens &&
    screens.access &&
    screens.access.length > 0 &&
    screens.access.map(({ route }) => {
      return route;
    });
  const navigate = useNavigate();
  // Your authentication logic goes here
  const isAuth = isAuthenticated();
  // if (!isAuth) {
  //   window.location.href = "/login";
  //   return;
  // }

  if (!accessPages) return <h1>Loading....</h1>;

  return (
    <React.Fragment>
      <Box display={isMobile ? 'content' : 'flex'}>
        {!isMobile && (
          <Box width="16.66%" bg="#eef2f5">
            <ResponsiveSidebarWrapper accessPages={accessPages} isOpen={isOpen} onClose={onClose} />
          </Box>
        )}

        <Box
          flex="1"
          bg="#eef2f5"
          overflowY="scroll"
          paddingBottom={8}
          height="100vh"
        >
          {isMobile && (
            <Box bg="#fff" boxShadow="md">
              <ResponsiveSidebarWrapper accessPages={accessPages} isMobile={true} isOpen={isOpen} onClose={onClose} />
            </Box>
          )}

          {(accessPages.includes(path) || path.includes('upload-trip') || path.includes('upload-truck')) ? (
            <Box>
              <DashboardHeader onOpen={onOpen} heading={`${pluralize(path)} Management`} />
              {children ?? <Outlet />}
            </Box>
          ) : (
            <>
              <DashboardHeader onOpen={onOpen} heading="Not Authorized" />
              <Box textAlign="center" py={10} px={6}>
                <Heading as="h2" size="xl" mt={6} mb={2}>
                  Not Authorized
                </Heading>
                <Text color={"gray.500"}>
                  You are not authorized to view this page.
                </Text>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default PrivateRoute;
